import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SocialLink {
  id: string;
  platform: string;
  label: string;
  url: string;
  icon_key: string;
  sort_order: number;
  enabled: boolean;
  created_at: string;
  updated_at: string;
}

export function useSocialLinks() {
  return useQuery({
    queryKey: ["social-links"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("social_links" as any)
        .select("*")
        .eq("enabled", true)
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return (data || []) as unknown as SocialLink[];
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}

export function useAllSocialLinks() {
  return useQuery({
    queryKey: ["social-links-all"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("social_links" as any)
        .select("*")
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return (data || []) as unknown as SocialLink[];
    },
  });
}
